(() => {
 const config=document.getElementById('cm-auto-localization');
 if(!config||window.Shopify?.designMode)return;
 const countryKey='cm-localization-country-manual-v4',languageKey='cm-localization-language-manual-v4',sessionKey='cm-localization-checked-v5';
 const read=(storage,key)=>{try{return storage.getItem(key)}catch{return null}};
 const write=(storage,key,value)=>{try{storage.setItem(key,value);return true}catch{return false}};
 const locked=key=>Boolean(read(sessionStorage,key));
 const countries=config.dataset.countries.split(','),languages=config.dataset.languages.split(',');
 const currentCountry=config.dataset.country,currentLanguage=config.dataset.language;
 let manualThisPage=false;

 const countryLanguages={};
 const groups={
  fr:'FR MC LU CD CG CI SN ML BF NE BJ GN TG GA CM CF TD KM DJ MG',
  it:'IT SM VA',
  de:'DE AT LI CH',
  nl:'NL BE SR',
  es:'ES MX AR BO CL CO CR CU DO EC GT HN NI PA PE PR PY SV UY VE GQ'
 };
 for(const [language,list] of Object.entries(groups))for(const country of list.split(' '))countryLanguages[country]=language;
 const languageForCountry=(country,available=languages)=>{
  const wanted=countryLanguages[country]||'en';
  return available.find(code=>code.toLowerCase()===wanted)||available.find(code=>code.toLowerCase().split('-')[0]===wanted)||available.find(code=>code.toLowerCase()==='en')||currentLanguage;
 };
 const setField=(form,name,value)=>{
  const fields=form.querySelectorAll('input[name="'+name+'"]');
  if(fields.length){for(const field of fields)field.value=value;}
  else{const input=document.createElement('input');input.type='hidden';input.name=name;input.value=value;form.append(input);}
 };
 const chooseCountry=(form,country)=>{
  if(!countries.includes(country))return;
  const language=languageForCountry(country);
  setField(form,'locale_code',language);
  setField(form,'language_code',language);
  try{sessionStorage.removeItem(languageKey)}catch{}
  write(sessionStorage,countryKey,String(Date.now()));manualThisPage=true;
 };

 const isForm=form=>{if(!(form instanceof HTMLFormElement)||form.id==='cm-auto-localization-form')return false;try{return new URL(form.action,location.origin).pathname.endsWith('/localization')}catch{return false}};
 const mark=(name,value)=>{
  if(name==='country_code'&&countries.includes(value)&&value!==currentCountry){write(sessionStorage,countryKey,String(Date.now()));manualThisPage=true}
  if(['locale_code','language_code'].includes(name)&&languages.includes(value)&&value!==currentLanguage){write(sessionStorage,languageKey,String(Date.now()));manualThisPage=true}
 };
 document.addEventListener('submit',event=>{if(isForm(event.target)){
 const button=event.submitter;
 const country=button?.name==='country_code'?button.value:event.target.classList.contains('cm-country-language-form')?event.target.querySelector('input[name="country_code"],select[name="country_code"]')?.value:null;
 if(country)chooseCountry(event.target,country);
 for(const [name,value]of new FormData(event.target))if(name==='country_code')mark(name,value);
 if(!country&&button)mark(button.name,button.value);
 }},true);
 document.addEventListener('change',event=>{if(isForm(event.target.form)){if(event.target.name==='country_code')chooseCountry(event.target.form,event.target.value);else mark(event.target.name,event.target.value)}},true);
 document.addEventListener('click',event=>{const choice=event.target.closest?.('[name="country_code"],[name="locale_code"],[name="language_code"]');if(choice&&isForm(choice.form)){if(choice.name==='country_code')chooseCountry(choice.form,choice.value);else mark(choice.name,choice.value)}},true);
 const params=new URLSearchParams(location.search);
 const explicitCountry=['country','country_code'].some(key=>params.has(key));
 const explicitLanguage=['locale','locale_code','language_code'].some(key=>params.has(key));
 if(explicitCountry)write(sessionStorage,countryKey,String(Date.now()));
 if(explicitLanguage)write(sessionStorage,languageKey,String(Date.now()));
 if(read(sessionStorage,sessionKey))return;
 if(!write(sessionStorage,sessionKey,'1'))return;
 const keepCountry=explicitCountry||locked(countryKey);
 const keepLanguage=explicitLanguage||locked(languageKey);
 if(keepCountry&&keepLanguage)return;
 const controller=new AbortController(),timeout=setTimeout(()=>controller.abort(),4000);
 const root=config.dataset.root.endsWith('/')?config.dataset.root:config.dataset.root+'/';
 const endpoint=new URL(root+'browsing_context_suggestions.json',location.origin);
 endpoint.search=new URLSearchParams({'country[enabled]':'true','language[enabled]':'true'});
 fetch(endpoint,{credentials:'same-origin',signal:controller.signal})
 .then(response=>{if(!response.ok)throw Error('Localization unavailable');return response.json()})
 .then(data=>{
  if(manualThisPage)return;
  const apply=()=>{
  if(manualThisPage)return;
  const parts=data.suggestions?.[0]?.parts||{};
  const detected=data.detected_values?.country?.handle||parts.country?.handle;
  const country=!keepCountry&&countries.includes(detected)?detected:currentCountry;
  const offered=parts.language?.options?Object.keys(parts.language.options):languages;
  const allowed=offered.filter(code=>languages.includes(code));
  let language=currentLanguage;
  if(!keepLanguage)language=languageForCountry(country,allowed.length?allowed:languages);
  if(country===currentCountry&&language===currentLanguage)return;
  const form=document.getElementById('cm-auto-localization-form');
  if(!(form instanceof HTMLFormElement))return;
  const action=new URL(form.getAttribute('action')||'',location.origin);
  if(action.origin!==location.origin||action.pathname!==new URL(root+'localization',location.origin).pathname)return;
  const values={form_type:'localization',_method:'PUT',country_code:country,language_code:language,return_to:location.pathname+location.search+location.hash};
  for(const[name,value]of Object.entries(values))setField(form,name,value);
  HTMLFormElement.prototype.submit.call(form);
  };
  if(document.hidden){
   const resume=()=>{if(!document.hidden){document.removeEventListener('visibilitychange',resume);apply();}};
   document.addEventListener('visibilitychange',resume);
  }else apply();
 }).catch(()=>{try{sessionStorage.removeItem(sessionKey)}catch{}}).finally(()=>clearTimeout(timeout));
})();